package com.eladfinish.bible.contest

import dev.icerock.moko.resources.StringResource
import dev.icerock.moko.resources.`internal`.SupportedLocale
import dev.icerock.moko.resources.`internal`.SupportedLocales
import dev.icerock.moko.resources.provider.RemoteJsStringLoader
import kotlin.String
import kotlin.collections.List

private val fallbackFileUrl: String =
    js("require(\"./localization/comeladfinishbiblecontest_stringsJson.json\")") as String

private val supportedLocales: SupportedLocales = SupportedLocales(listOf(
    SupportedLocale("de",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_de.json\")") as String),
    SupportedLocale("en",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_en.json\")") as String),
    SupportedLocale("es",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_es.json\")") as String),
    SupportedLocale("fr",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_fr.json\")") as String),
    SupportedLocale("ru",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_ru.json\")") as String),
    ))

private val stringsLoader: RemoteJsStringLoader = RemoteJsStringLoader.Impl(supportedLocales =
    supportedLocales, fallbackFileUri = fallbackFileUrl)

internal object CommonMainStrings8 {
  internal val purchase_already_owned: StringResource by lazy { init_purchase_already_owned() }

  internal val purchase_canceled: StringResource by lazy { init_purchase_canceled() }

  internal val purchase_debug_consume_test_purchase: StringResource by lazy {
      init_purchase_debug_consume_test_purchase() }

  internal val purchase_debug_no_test_purchases: StringResource by lazy {
      init_purchase_debug_no_test_purchases() }

  internal val purchase_debug_test_purchase_consumed: StringResource by lazy {
      init_purchase_debug_test_purchase_consumed() }

  internal val purchase_failed: StringResource by lazy { init_purchase_failed() }

  internal val purchase_is_now_available: StringResource by lazy { init_purchase_is_now_available()
      }

  internal val purchase_not_available: StringResource by lazy { init_purchase_not_available() }

  internal val purchase_nothing_to_restore: StringResource by lazy {
      init_purchase_nothing_to_restore() }

  internal val purchase_remove_ads: StringResource by lazy { init_purchase_remove_ads() }

  internal val purchase_restore: StringResource by lazy { init_purchase_restore() }

  internal val purchase_restored: StringResource by lazy { init_purchase_restored() }

  internal val purchase_successful: StringResource by lazy { init_purchase_successful() }

  internal val purchase_upsell: StringResource by lazy { init_purchase_upsell() }

  internal val pyramid_crossword: StringResource by lazy { init_pyramid_crossword() }

  internal val qri: StringResource by lazy { init_qri() }

  internal val question: StringResource by lazy { init_question() }

  internal val question_and_answer_are_required: StringResource by lazy {
      init_question_and_answer_are_required() }

  internal val question_example: StringResource by lazy { init_question_example() }

  internal val question_identifier: StringResource by lazy { init_question_identifier() }

  internal val question_recorded: StringResource by lazy { init_question_recorded() }

  internal val questions_according_to_mikud: StringResource by lazy {
      init_questions_according_to_mikud() }

  internal val questions_and_answers_from: StringResource by lazy {
      init_questions_and_answers_from() }

  internal val questions_are_over: StringResource by lazy { init_questions_are_over() }

  internal val questions_by_books_education_ministry: StringResource by lazy {
      init_questions_by_books_education_ministry() }

  internal val questions_from_pair_matching: StringResource by lazy {
      init_questions_from_pair_matching() }

  internal val questions_from_server_have_been_deleted: StringResource by lazy {
      init_questions_from_server_have_been_deleted() }

  internal val questions_from_users: StringResource by lazy { init_questions_from_users() }

  internal val questions_have_not_yet_been_added_to_this_mikud: StringResource by lazy {
      init_questions_have_not_yet_been_added_to_this_mikud() }

  internal val random_approach: StringResource by lazy { init_random_approach() }

  internal val random_verse: StringResource by lazy { init_random_verse() }

  internal val random_verses_cocktail: StringResource by lazy { init_random_verses_cocktail() }

  internal val rate: StringResource by lazy { init_rate() }

  internal val rating_in_google_play: StringResource by lazy { init_rating_in_google_play() }

  internal val regular_search: StringResource by lazy { init_regular_search() }

  internal val remove_duplicates: StringResource by lazy { init_remove_duplicates() }

  internal val remove_verse_origin: StringResource by lazy { init_remove_verse_origin() }

  internal val rename: StringResource by lazy { init_rename() }

  internal val restore: StringResource by lazy { init_restore() }

  internal val restore_default: StringResource by lazy { init_restore_default() }

  internal val results: StringResource by lazy { init_results() }

  internal val reward_earned_success: StringResource by lazy { init_reward_earned_success() }

  internal val rewarded_ad_dialog_content: StringResource by lazy {
      init_rewarded_ad_dialog_content() }

  internal val reyshot: StringResource by lazy { init_reyshot() }

  internal val reyshot_value: StringResource by lazy { init_reyshot_value() }

  internal val right_arrow: StringResource by lazy { init_right_arrow() }

  internal val roll_dice: StringResource by lazy { init_roll_dice() }

  internal val rosh_chodesh: StringResource by lazy { init_rosh_chodesh() }

  internal val sample_question: StringResource by lazy { init_sample_question() }

  internal val save: StringResource by lazy { init_save() }

  internal fun values(): List<StringResource> = listOf(purchase_already_owned, purchase_canceled,
      purchase_debug_consume_test_purchase, purchase_debug_no_test_purchases,
      purchase_debug_test_purchase_consumed, purchase_failed, purchase_is_now_available,
      purchase_not_available, purchase_nothing_to_restore, purchase_remove_ads, purchase_restore,
      purchase_restored, purchase_successful, purchase_upsell, pyramid_crossword, qri, question,
      question_and_answer_are_required, question_example, question_identifier, question_recorded,
      questions_according_to_mikud, questions_and_answers_from, questions_are_over,
      questions_by_books_education_ministry, questions_from_pair_matching,
      questions_from_server_have_been_deleted, questions_from_users,
      questions_have_not_yet_been_added_to_this_mikud, random_approach, random_verse,
      random_verses_cocktail, rate, rating_in_google_play, regular_search, remove_duplicates,
      remove_verse_origin, rename, restore, restore_default, results, reward_earned_success,
      rewarded_ad_dialog_content, reyshot, reyshot_value, right_arrow, roll_dice, rosh_chodesh,
      sample_question, save)
}

private fun init_purchase_already_owned(): StringResource = StringResource(key =
    "purchase_already_owned", loader = stringsLoader)

private fun init_purchase_canceled(): StringResource = StringResource(key = "purchase_canceled",
    loader = stringsLoader)

private fun init_purchase_debug_consume_test_purchase(): StringResource = StringResource(key =
    "purchase_debug_consume_test_purchase", loader = stringsLoader)

private fun init_purchase_debug_no_test_purchases(): StringResource = StringResource(key =
    "purchase_debug_no_test_purchases", loader = stringsLoader)

private fun init_purchase_debug_test_purchase_consumed(): StringResource = StringResource(key =
    "purchase_debug_test_purchase_consumed", loader = stringsLoader)

private fun init_purchase_failed(): StringResource = StringResource(key = "purchase_failed", loader
    = stringsLoader)

private fun init_purchase_is_now_available(): StringResource = StringResource(key =
    "purchase_is_now_available", loader = stringsLoader)

private fun init_purchase_not_available(): StringResource = StringResource(key =
    "purchase_not_available", loader = stringsLoader)

private fun init_purchase_nothing_to_restore(): StringResource = StringResource(key =
    "purchase_nothing_to_restore", loader = stringsLoader)

private fun init_purchase_remove_ads(): StringResource = StringResource(key = "purchase_remove_ads",
    loader = stringsLoader)

private fun init_purchase_restore(): StringResource = StringResource(key = "purchase_restore",
    loader = stringsLoader)

private fun init_purchase_restored(): StringResource = StringResource(key = "purchase_restored",
    loader = stringsLoader)

private fun init_purchase_successful(): StringResource = StringResource(key = "purchase_successful",
    loader = stringsLoader)

private fun init_purchase_upsell(): StringResource = StringResource(key = "purchase_upsell", loader
    = stringsLoader)

private fun init_pyramid_crossword(): StringResource = StringResource(key = "pyramid_crossword",
    loader = stringsLoader)

private fun init_qri(): StringResource = StringResource(key = "qri", loader = stringsLoader)

private fun init_question(): StringResource = StringResource(key = "question", loader =
    stringsLoader)

private fun init_question_and_answer_are_required(): StringResource = StringResource(key =
    "question_and_answer_are_required", loader = stringsLoader)

private fun init_question_example(): StringResource = StringResource(key = "question_example",
    loader = stringsLoader)

private fun init_question_identifier(): StringResource = StringResource(key = "question_identifier",
    loader = stringsLoader)

private fun init_question_recorded(): StringResource = StringResource(key = "question_recorded",
    loader = stringsLoader)

private fun init_questions_according_to_mikud(): StringResource = StringResource(key =
    "questions_according_to_mikud", loader = stringsLoader)

private fun init_questions_and_answers_from(): StringResource = StringResource(key =
    "questions_and_answers_from", loader = stringsLoader)

private fun init_questions_are_over(): StringResource = StringResource(key = "questions_are_over",
    loader = stringsLoader)

private fun init_questions_by_books_education_ministry(): StringResource = StringResource(key =
    "questions_by_books_education_ministry", loader = stringsLoader)

private fun init_questions_from_pair_matching(): StringResource = StringResource(key =
    "questions_from_pair_matching", loader = stringsLoader)

private fun init_questions_from_server_have_been_deleted(): StringResource = StringResource(key =
    "questions_from_server_have_been_deleted", loader = stringsLoader)

private fun init_questions_from_users(): StringResource = StringResource(key =
    "questions_from_users", loader = stringsLoader)

private fun init_questions_have_not_yet_been_added_to_this_mikud(): StringResource =
    StringResource(key = "questions_have_not_yet_been_added_to_this_mikud", loader = stringsLoader)

private fun init_random_approach(): StringResource = StringResource(key = "random_approach", loader
    = stringsLoader)

private fun init_random_verse(): StringResource = StringResource(key = "random_verse", loader =
    stringsLoader)

private fun init_random_verses_cocktail(): StringResource = StringResource(key =
    "random_verses_cocktail", loader = stringsLoader)

private fun init_rate(): StringResource = StringResource(key = "rate", loader = stringsLoader)

private fun init_rating_in_google_play(): StringResource = StringResource(key =
    "rating_in_google_play", loader = stringsLoader)

private fun init_regular_search(): StringResource = StringResource(key = "regular_search", loader =
    stringsLoader)

private fun init_remove_duplicates(): StringResource = StringResource(key = "remove_duplicates",
    loader = stringsLoader)

private fun init_remove_verse_origin(): StringResource = StringResource(key = "remove_verse_origin",
    loader = stringsLoader)

private fun init_rename(): StringResource = StringResource(key = "rename", loader = stringsLoader)

private fun init_restore(): StringResource = StringResource(key = "restore", loader = stringsLoader)

private fun init_restore_default(): StringResource = StringResource(key = "restore_default", loader
    = stringsLoader)

private fun init_results(): StringResource = StringResource(key = "results", loader = stringsLoader)

private fun init_reward_earned_success(): StringResource = StringResource(key =
    "reward_earned_success", loader = stringsLoader)

private fun init_rewarded_ad_dialog_content(): StringResource = StringResource(key =
    "rewarded_ad_dialog_content", loader = stringsLoader)

private fun init_reyshot(): StringResource = StringResource(key = "reyshot", loader = stringsLoader)

private fun init_reyshot_value(): StringResource = StringResource(key = "reyshot_value", loader =
    stringsLoader)

private fun init_right_arrow(): StringResource = StringResource(key = "right_arrow", loader =
    stringsLoader)

private fun init_roll_dice(): StringResource = StringResource(key = "roll_dice", loader =
    stringsLoader)

private fun init_rosh_chodesh(): StringResource = StringResource(key = "rosh_chodesh", loader =
    stringsLoader)

private fun init_sample_question(): StringResource = StringResource(key = "sample_question", loader
    = stringsLoader)

private fun init_save(): StringResource = StringResource(key = "save", loader = stringsLoader)

public actual val SharedRes.strings.purchase_already_owned: StringResource
  get() = CommonMainStrings8.purchase_already_owned

public actual val SharedRes.strings.purchase_canceled: StringResource
  get() = CommonMainStrings8.purchase_canceled

public actual val SharedRes.strings.purchase_debug_consume_test_purchase: StringResource
  get() = CommonMainStrings8.purchase_debug_consume_test_purchase

public actual val SharedRes.strings.purchase_debug_no_test_purchases: StringResource
  get() = CommonMainStrings8.purchase_debug_no_test_purchases

public actual val SharedRes.strings.purchase_debug_test_purchase_consumed: StringResource
  get() = CommonMainStrings8.purchase_debug_test_purchase_consumed

public actual val SharedRes.strings.purchase_failed: StringResource
  get() = CommonMainStrings8.purchase_failed

public actual val SharedRes.strings.purchase_is_now_available: StringResource
  get() = CommonMainStrings8.purchase_is_now_available

public actual val SharedRes.strings.purchase_not_available: StringResource
  get() = CommonMainStrings8.purchase_not_available

public actual val SharedRes.strings.purchase_nothing_to_restore: StringResource
  get() = CommonMainStrings8.purchase_nothing_to_restore

public actual val SharedRes.strings.purchase_remove_ads: StringResource
  get() = CommonMainStrings8.purchase_remove_ads

public actual val SharedRes.strings.purchase_restore: StringResource
  get() = CommonMainStrings8.purchase_restore

public actual val SharedRes.strings.purchase_restored: StringResource
  get() = CommonMainStrings8.purchase_restored

public actual val SharedRes.strings.purchase_successful: StringResource
  get() = CommonMainStrings8.purchase_successful

public actual val SharedRes.strings.purchase_upsell: StringResource
  get() = CommonMainStrings8.purchase_upsell

public actual val SharedRes.strings.pyramid_crossword: StringResource
  get() = CommonMainStrings8.pyramid_crossword

public actual val SharedRes.strings.qri: StringResource
  get() = CommonMainStrings8.qri

public actual val SharedRes.strings.question: StringResource
  get() = CommonMainStrings8.question

public actual val SharedRes.strings.question_and_answer_are_required: StringResource
  get() = CommonMainStrings8.question_and_answer_are_required

public actual val SharedRes.strings.question_example: StringResource
  get() = CommonMainStrings8.question_example

public actual val SharedRes.strings.question_identifier: StringResource
  get() = CommonMainStrings8.question_identifier

public actual val SharedRes.strings.question_recorded: StringResource
  get() = CommonMainStrings8.question_recorded

public actual val SharedRes.strings.questions_according_to_mikud: StringResource
  get() = CommonMainStrings8.questions_according_to_mikud

public actual val SharedRes.strings.questions_and_answers_from: StringResource
  get() = CommonMainStrings8.questions_and_answers_from

public actual val SharedRes.strings.questions_are_over: StringResource
  get() = CommonMainStrings8.questions_are_over

public actual val SharedRes.strings.questions_by_books_education_ministry: StringResource
  get() = CommonMainStrings8.questions_by_books_education_ministry

public actual val SharedRes.strings.questions_from_pair_matching: StringResource
  get() = CommonMainStrings8.questions_from_pair_matching

public actual val SharedRes.strings.questions_from_server_have_been_deleted: StringResource
  get() = CommonMainStrings8.questions_from_server_have_been_deleted

public actual val SharedRes.strings.questions_from_users: StringResource
  get() = CommonMainStrings8.questions_from_users

public actual val SharedRes.strings.questions_have_not_yet_been_added_to_this_mikud: StringResource
  get() = CommonMainStrings8.questions_have_not_yet_been_added_to_this_mikud

public actual val SharedRes.strings.random_approach: StringResource
  get() = CommonMainStrings8.random_approach

public actual val SharedRes.strings.random_verse: StringResource
  get() = CommonMainStrings8.random_verse

public actual val SharedRes.strings.random_verses_cocktail: StringResource
  get() = CommonMainStrings8.random_verses_cocktail

public actual val SharedRes.strings.rate: StringResource
  get() = CommonMainStrings8.rate

public actual val SharedRes.strings.rating_in_google_play: StringResource
  get() = CommonMainStrings8.rating_in_google_play

public actual val SharedRes.strings.regular_search: StringResource
  get() = CommonMainStrings8.regular_search

public actual val SharedRes.strings.remove_duplicates: StringResource
  get() = CommonMainStrings8.remove_duplicates

public actual val SharedRes.strings.remove_verse_origin: StringResource
  get() = CommonMainStrings8.remove_verse_origin

public actual val SharedRes.strings.rename: StringResource
  get() = CommonMainStrings8.rename

public actual val SharedRes.strings.restore: StringResource
  get() = CommonMainStrings8.restore

public actual val SharedRes.strings.restore_default: StringResource
  get() = CommonMainStrings8.restore_default

public actual val SharedRes.strings.results: StringResource
  get() = CommonMainStrings8.results

public actual val SharedRes.strings.reward_earned_success: StringResource
  get() = CommonMainStrings8.reward_earned_success

public actual val SharedRes.strings.rewarded_ad_dialog_content: StringResource
  get() = CommonMainStrings8.rewarded_ad_dialog_content

public actual val SharedRes.strings.reyshot: StringResource
  get() = CommonMainStrings8.reyshot

public actual val SharedRes.strings.reyshot_value: StringResource
  get() = CommonMainStrings8.reyshot_value

public actual val SharedRes.strings.right_arrow: StringResource
  get() = CommonMainStrings8.right_arrow

public actual val SharedRes.strings.roll_dice: StringResource
  get() = CommonMainStrings8.roll_dice

public actual val SharedRes.strings.rosh_chodesh: StringResource
  get() = CommonMainStrings8.rosh_chodesh

public actual val SharedRes.strings.sample_question: StringResource
  get() = CommonMainStrings8.sample_question

public actual val SharedRes.strings.save: StringResource
  get() = CommonMainStrings8.save
